// Botanical Sage — Social Post design #3.
//
// Ported from the Claude Design standalone bundle (posts.jsx PostBotanical).
// Renders at a fixed 1080×1080 reference size. Parent (StepSocialFinal)
// scales it via CSS transform.
//
// Visual: dark sage green canvas, gold accent typography, italic display
// headline, roman-numeral bullets, dark green product frame with bracket
// corners.

import type { SocialPostSlots } from '@/lib/api';
import './PostBotanical.css';

interface PostBotanicalProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostBotanical({ slots, productImageUrl }: PostBotanicalProps) {
  return (
    <div className="post-botanical">
      <div className="frame-pad">
        <div className="top">
          <div className="brandlogo">
            {slots.brand_name || ''}{' '}
            {slots.brand_tagline ? (
              <span style={{ opacity: .5 }}>· {slots.brand_tagline}</span>
            ) : null}
          </div>
          <div className="badge">
            <span className="stars">{slots.badge_stars}</span>
            <span>{slots.badge_text}</span>
          </div>
        </div>
        <div className="core">
          <div className="left">
            <div>
              <div className="eyebrow">{slots.eyebrow}</div>
              <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
              <div className="sub">{slots.subhead}</div>
            </div>
            <ul className="bullets">
              <li><span className="n">i.</span><span>{slots.bullet1}</span></li>
              <li><span className="n">ii.</span><span>{slots.bullet2}</span></li>
              <li><span className="n">iii.</span><span>{slots.bullet3}</span></li>
            </ul>
          </div>
          <div className="right">
            <div className="product">
              {productImageUrl ? (
                <img src={productImageUrl} alt="Product" />
              ) : (
                <div className="empty-state">Product image</div>
              )}
            </div>
            <div className="caption">
              <span>{slots.caption_left || ''}</span>
              <span className="price">{slots.caption_right || ''}</span>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="handle">Find us at <span>{slots.handle}</span></div>
          <div className="cta">{slots.cta} →</div>
        </div>
      </div>
    </div>
  );
}
